import React from 'react';
import ImageHelp from './imageHelp';
import statusImage from '../../../../assets/images/help/statut.png';
import { Card } from 'reactstrap';
import { FaHandPointDown } from 'react-icons/fa';

const CatalogHelp = () => {
    return (
        <div className="helpContainer">
            <h2 className="helpTitle">Gestion des Statuts</h2>
            <p className="description">
                Cette section vous permet de gérer les statuts des véhicules, des inspections, et des tâches liées à votre flotte.
                Vous pouvez définir, mettre à jour, et suivre l'état de chaque élément dans votre système dans l'onglet Statut.
                Découvrez les fonctionnalités ci-dessous pour une gestion efficace de vos statuts :
            </p>

            <div className="helpFeaturesAndImageContainer">
                <div className="helpTextContainer">
                    <ul className="helpFeaturesList">
                        <li><strong>Définition des statuts :</strong> Créez et gérez les différents statuts de l'application.</li>
                        <li><strong>Modification des statuts :</strong> Mettez à jour les statuts des éléments pour refléter les changements.</li>
                        <li><strong>Suppression des statuts :</strong> Supprimez les statuts obsolètes ou non utilisés de votre flotte.</li>
                        <li><strong>Utilisateur :</strong> Le statut des utilisateurs peut être des statuts <em>'Actif'</em> ou <em>'Inactif'</em> aux utilisateurs..</li>
                        <li><strong>Véhicule :</strong> "Le statut du véhicule peut être défini comme <em>'En service'</em> ou <em>'Hors service</em>'.</li>
                        <li><strong>Inspections :</strong> Les inspections peuvent être <em>Ciblées</em> ou <em>Completes</em>.</li>
                        <li><strong>Ciblées :</strong> Si l'inspection est <em>ciblée</em> alors on doit renseigner les questions liées à cette inspection.</li>
                        <li><strong>Completes :</strong> Les inspections completes sont l'ensemble des inspections ciblées.</li>
                    </ul>
                    
                </div>
                <div className="helpImageContainer">
                    <p className="helpBase">
                        Cliquez sur l'image pour voir de près. <FaHandPointDown className="animated-icon" />
                    </p>
                    <Card className="card-animate">
                        <ImageHelp fileSource={statusImage} width="100%" />
                    </Card>
                </div>
            </div>

            <p className="helpBase">
                Pour plus de détails ou pour toute question, contactez le support technique de Systalink.
            </p>
        </div>
    );
};

export default CatalogHelp;
